// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/scss/editor.scss
// module id = ./resources/scss/editor.scss
// module chunks = 0